// redex/users/userActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { createUserApi, updatePasswordApi, usersListApi, updateUserWorkStatusApi } from "./userApi";
import { showApiErrorToast } from "../../utils/toastErrorHandler";

/* The session ends on 401 and only on 401 — a request that failed is not a
   token that expired. Clearing on any error signed the whole app out over a
   500 or a refused form, and left the header reading a key that was no longer
   there. Same guard as taskActions.js. */
const endSessionIfUnauthorized = (err) => {
  if (err?.response?.status !== 401) return;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

// Thunk for Creating Data
export const createUserApis = createAsyncThunk(
  "usersApi/create", // Unique string identifier
  async (payload, { rejectWithValue }) => {
    try {
      return await createUserApi(payload);
    } catch (err) {
      // Return the specific error message from the API
      endSessionIfUnauthorized(err);

      showApiErrorToast(err?.response?.data?.error || err.message);

      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);

export const usersApis = createAsyncThunk(
  "usersApi/usersApi",
  async (payload, { rejectWithValue }) => {
    try {
      return await usersListApi(payload);
    } catch (err) {
      // localStorage.removeItem("token");
      // localStorage.removeItem("user");
      showApiErrorToast(err?.response?.data?.error || err.message);
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  },
);

export const updatePasswordApis = createAsyncThunk(
  "updatePasswordData/create", // Unique string identifier
  async (payload, { rejectWithValue }) => {
    try {
      return await updatePasswordApi(payload);
    } catch (err) {
      // Return the specific error message from the API
      return rejectWithValue(err?.message || "Failed to create task");
    }
  },
);



// 2. Add this new thunk to the bottom of the file
export const updateUserWorkStatusApis = createAsyncThunk(
  "usersApi/updateWorkStatus", // Unique string identifier
  async (payload, { rejectWithValue }) => {

      console.log(payload, 'payload23423');
      
    try {
      return await updateUserWorkStatusApi(payload);
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to update work status");
    }
  },
);